// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3i_VU","inputWrap":"Table_inputWrap__ZSYNf","col":"Table_col__3qhcG","bmiTooltip":"Table_bmiTooltip__8L6mc"};